module.exports = __webpack_public_path__ + "static/media/game_detail_bind_next.c53c5f6d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/game_detail_bind_next.png
// module id = 494
// module chunks = 39